import { render, staticRenderFns } from "./Diamond.vue?vue&type=template&id=c3be8006"
import script from "./Diamond.vue?vue&type=script&lang=ts"
export * from "./Diamond.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports